export const PERMISSION_GROUPS = {
    DASHBOARDS: "Dashboards",
    USERS: "Users",
    BOOKINGS: "bookings",
    SURVEYS: "surveys",
    INVOICING: "Invoicing",
    OTHERS: "Others",
    RESPONDENTS: "Respondents",
    WORKFLOWS_AND_AUTOMATIONS: "Workflows and Automations",
};
//# sourceMappingURL=permissionGroups.js.map